import React, { useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../Firebase_Config/firebase";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import './AccountMang.css';

const PrivacyPolicy= () => {
 
  const d = new Date();
    let year = d.getFullYear();
  return (
    <div style={{
      backgroundImage: `linear-gradient(195deg, rgba(66, 66, 74, 0.6), rgba(25, 25, 25, 0.6)), url('bg.jpeg')`,
      backgroundSize: 'cover',
      backgroundAttachment: 'fixed',
      backgroundPosition: 'center center',
      minheight: '100vh'
    }}>
      <div className="polcontent">
        <div className="Polheader">
            <h2 className="Signh2">Privacy Policy</h2>
          </div>
          <br/>
        <div className="privPol-Box">
          <ol>
            <li><b>Introduction</b>
              <p>This privacy policy explains how all data—including both personal and non-personal data—is collected, used, and protected when using our tools for AI conformity analysis and responsible AI assessment.</p>
              <p>These tools are designed to evaluate whether AI systems are developed and deployed in accordance with responsible AI guidelines, standards, and regulations. Processing activities may include model evaluation, data anonymisation, data profiling, privacy breach testing, and conformity reporting. All data is used exclusively for these compliance and assessment purposes and is deleted once processing is complete, in line with the UK GDPR, the Data Protection Act 2018, and applicable best practices for non-personal data management.</p>
            </li>
            <li><b>Data Controller</b>
              <p>The data controller responsible for all data processed through these tools is Your Company Name, Contact Details.</p>
            </li>
            <li><b>Purpose and Lawful Basis for Processing</b>
              <p>All data is processed solely for the following purposes:</p>
              <ul>
                <li>Assessing AI models for conformity with responsible AI standards, ethical guidelines, and regulatory requirements.</li>
                <li>Conducting model evaluation, data anonymisation, data profiling, and privacy breach testing to identify and mitigate risks.</li>
                <li>Generating conformity analysis reports and compliance documentation.</li>
              </ul>
              <p>For personal data, the lawful basis for processing is choose: legitimate interests, legal obligation, or consent, as appropriate. Non-personal data is processed in accordance with applicable contractual and regulatory obligations. No data is used for any other purpose.</p>
            </li>
            <li><b>Data Minimisation and Relevance</b>
              <p>Only data strictly necessary for conformity analysis and responsible AI assessment is collected and processed. The tools are designed to ensure all data—personal or non-personal—is adequate, relevant, and limited to what is necessary for the stated compliance activities.</p>
            </li>
            <li><b>Data Retention and Deletion</b>
              <p>All data collected for conformity analysis and assessment is deleted immediately upon completion of processing. No data, whether personal or non-personal, is retained beyond the period necessary to fulfil the assessment and reporting function.</p>
            </li>
            <li><b>Data Security</b>
              <p>Robust technical and organisational measures are implemented to protect all data against unauthorised access, loss, destruction, or damage. These include encryption, access controls, secure data handling procedures, and regular audits. Security protocols are aligned with the sensitivity and volume of data processed and are regularly reviewed and updated.</p>
            </li>
            <li><b>Data Sharing</b>
              <p>Data is not shared with third parties except where required by law or regulation. No data is transferred outside the UK or EEA unless adequate safeguards are in place.</p>
            </li>
            <li><b>Automated Decision-Making and Profiling</b>
              <p>Where automated decision-making or profiling is used (e.g., for model evaluation or data profiling), human oversight is maintained in accordance with Article 22 of the UK GDPR for personal data. Explanations about the logic involved in such processing are available upon request.</p>
            </li>
            <li><b>Your Rights (for Personal Data)</b>
              <p>Under the UK GDPR and Data Protection Act 2018, individuals have rights in relation to their personal data, including:</p>
              <ul>
                <li>The right to be informed about how data is used</li>
                <li>The right to access personal data</li>
                <li>The right to rectification</li>
                <li>The right to erasure</li>
                <li>The right to restrict or object to processing in certain circumstances</li>
                <li>The right to lodge a complaint with the Information Commissioner’s Office (ICO)</li>
              </ul>
              <br/>
            </li>
            <li><b>Contact and Complaints</b>
              <p>For questions about this policy or your data, please contact Data Protection Officer at info@assentian.com . If you believe your data has not been handled in accordance with the law, you may contact the ICO (Information Commissioner’s Office, Wycliffe House, Water Lane, Wilmslow, Cheshire, SK9 5AF).</p>
            </li>
            <li><b>Changes to this Policy</b>
              <p>This policy may be updated to reflect changes in legal or regulatory requirements.</p>
              <p>This policy ensures the responsible handling of all data—personal and non-personal—in line with the principles of lawfulness, fairness, transparency, purpose limitation, data minimisation, accuracy, storage limitation, integrity, and confidentiality as required under the UK GDPR, the Data Protection Act 2018, and best practices for non-personal data</p>
            </li>
          </ol>
          <p className="centercopy">© Copyright, {year} Assentian. All Rights Reserved</p>
        </div>
      </div>
      
    </div>
  );
}

export default PrivacyPolicy;
